import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Home as HomeIcon, Heart as HeartIcon, ShoppingBag as ShoppingBagIcon, Truck as TruckIcon, ArrowLeft } from 'lucide-react';
import { useCart } from '../context/CartContext';
import TopBar from '../components/TopBar';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import './Wishlist.css';

const Wishlist = () => {
  const { wishlist, wishlistCount, cartCount } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="wishlist-page-wrapper">
      {/* Announcement Bar */}
      <TopBar />

      {/* Main Header */}
      <Header 
        wishlistCount={wishlistCount} 
        cartCount={cartCount} 
        onCartClick={() => navigate('/cart')} 
      />

      {/* Navigation Bar */}
      <Navbar activeItem="Wishlist" />

      {/* Main Content */}
      <main className="wishlist-main">
        <div className="container">
          <div className="wishlist-header-row">
            <Link to="/" className="back-btn">
              <ArrowLeft size={16} />
              <span>Back to Shop</span>
            </Link>
            <h1 className="wishlist-page-title">
              <HeartIcon 
                size={24} 
                fill="var(--primary-green)" 
                color="var(--primary-green)" 
                style={{ marginRight: '10px', verticalAlign: 'middle' }} 
              />
              My Wishlist ({wishlist.length})
            </h1>
          </div>

          {wishlist.length > 0 ? (
            <div className="wishlist-grid">
              {wishlist.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          ) : (
            <div className="wishlist-empty-state">
              <div className="empty-heart-icon-wrapper">
                <HeartIcon size={40} color="var(--primary-green)" />
              </div>
              <h2>Your Wishlist is Empty</h2>
              <p>Explore our premium range of nuts, makhanas, and seeds to add items to your wishlist.</p>
              <Link to="/" className="btn-continue-shopping">
                Start Shopping
              </Link>
            </div>
          )}
        </div>
      </main>

      {/* Footer */}
      <Footer />

      {/* Sticky Bottom Navigation (Mobile screens only) */}
      <div className="mobile-sticky-nav" role="navigation" aria-label="Mobile Navigation">
        <Link 
          to="/" 
          className="mobile-nav-item"
        >
          <HomeIcon size={20} />
          <span>Home</span>
        </Link>
        <Link 
          to="/track" 
          className="mobile-nav-item"
        >
          <TruckIcon size={20} />
          <span>Track Order</span>
        </Link>
        <Link 
          to="/wishlist" 
          className="mobile-nav-item active"
        >
          <HeartIcon size={20} />
          {wishlistCount > 0 && (
            <span className="badge-count">{wishlistCount}</span>
          )}
          <span>Wishlist</span>
        </Link>
        <Link 
          to="/cart" 
          className="mobile-nav-item"
        >
          <ShoppingBagIcon size={20} />
          {cartCount > 0 && (
            <span className="badge-count">{cartCount}</span>
          )}
          <span>Cart</span>
        </Link>
      </div>
    </div>
  );
};

export default Wishlist;
